import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Badge from './Badge';
import * as appDataActions from '../../../actions/appDataActions';
import * as userDataActions from '../../../actions/userDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as localStorage from '../../../localStorage/localStorage';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';

class BadgeCollect extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            userData: this.props.userData,
            badge_id: this.props.badge_id,
            badge: this.props.badge,
            userBadge: this.props.userBadge,
            showAchievedCount: false,
            showAchievedState: true,
            collected: appHelper.isDefined(this.props.collected) ? this.props.collected : false,
            locale: {},
            checkBagdeCollected: false,
            collect_label: appHelper.getLocaleString("collect_label")
        };
        this.show = this.show.bind(this);
        this.getLocale = this.getLocale.bind(this);
        this.collect = this.collect.bind(this);
        this.checkCollected = this.checkCollected.bind(this);
        this.handleProgression = this.handleProgression.bind(this);
    }

    componentDidMount() {
        this.checkCollected();
        this.getLocale();
        if(appHelper.isDefined(this.props.animate) && this.props.animate){
            this.show();
        }
    }

    componentWillReceiveProps(nextProps) {

        if (this.state.userData !== nextProps.userData) {
            this.setState({userData: Object.assign({}, nextProps.userData), checkBagdeCollected: true});
        }

        if (this.state.userBadge !== nextProps.userBadge) {
            this.setState({userBadge: Object.assign({}, nextProps.userBadge)});
        }
        if (appHelper.isDefined(nextProps.collected) && this.state.collected !== nextProps.collected) {
            this.setState({collected: nextProps.collected});
        }
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.badge),
                collect_label: appHelper.getLocaleString("collect_label")
            });
        }
    }

    componentDidUpdate() {
        if (this.state.checkBagdeCollected && !this.state.collected) {
            this.checkCollected();
        }
    }

    getLocale() {
        let locale = appHelper.getLocalData(this.state.badge);
        this.setState({locale: Object.assign({}, locale)});
    }

    checkCollected() {
        this.setState({checkBagdeCollected: false});
        let params = {
            bite_id: this.props.bite_id,
            asset_id: this.props.asset_id
        };
        let badgesCollected = userDataHelper.checkBadgeEarnedOnObject(this.state.userData, params);
        let collectedIndex = appHelper.getArrayObjectIndexByKey(badgesCollected, "badge_id", this.state.badge.badge_id);
        if (collectedIndex > -1) {
            this.setState({collected: true});
            if (appHelper.isDefined(this.props.onCollected)) {
                this.props.onCollected();
            }

        }
    }

    collect(event) {
        event.stopPropagation();
        this.setState({collected: true});

        let params = {
            badge: this.state.badge,
            bite_id: this.props.bite_id,
            asset_id: this.props.asset_id
        };
        this.props.actions.collectBadge(params).then((userData) => {
            this.props.actions.setSuspendData(userData).then((trackingData) => {
                if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
                    this.props.actions.setBadgeStatement(this.state.badge).then((statement) => {
                        this.props.onCollected();
                    }).catch(error => {
                        this.props.onCollected();
                    });
                } else {
                    this.props.onCollected();
                }
            }).catch(error => {
            });
        }).catch(error => {
        });
    }

    handleProgression() {

    }

    show() {
        let collectRef = this.refs[`badgeCollect_${this.state.badge_id}`];
        if(appHelper.isDefined(collectRef)) {
            TweenLite.set(collectRef, {height: "auto"});
            TweenLite.from(collectRef, objectConstants.SHOW_PANEL_DURATION, {
                height: 0,
                ease: Expo.easeInOut
            });
        }
    }

    render() {
        return (
            <div className="kpi-overview-panel badge-badge-collection" ref={`badgeCollect_${this.state.badge_id}`}>

                <div className="kpi-overview-row"  ref={`badge_${this.state.badge_id}`}>
                    <div className="kpi-meter-col">
                        <Badge badge={this.state.badge}
                               userBadge={this.state.userBadge}
                               showAchievedCount={this.state.showAchievedCount}
                               showAchievedState={this.state.showAchievedState}/>
                    </div>
                    <div className="kpi-content-col">
                        <h4><strong>{this.state.locale.long_title}</strong></h4>
                        <div dangerouslySetInnerHTML={{__html: this.state.locale.collection_statement}}/>
                        {!this.state.collected
                            ?

                                <div className="text-center">
                                    <Button label={this.state.collect_label}
                                            id={`${this.state.badge_id}_button`}
                                            onClick={this.collect}/>
                                </div>

                            : null
                        }
                    </div>
                </div>

            </div>


        );
    }
}

/*OLD
* <div className="badge-collection-panel" ref={`badge_${this.state.badge_id}`}>
                <div className="collect-left-col">
                    <Badge badge={this.state.badge}
                           userBadge={this.state.userBadge}
                           showAchievedCount={this.state.showAchievedCount}
                           showAchievedState={this.state.showAchievedState}/>
                </div>
                <div className="collect-right-col">
                    <div><strong>{this.state.locale.long_title}</strong></div>
                    <div dangerouslySetInnerHTML={{__html: this.state.locale.collection_statement}}/>
                </div>
                {!this.state.collected
                    ?
                    <div className="collect-full-col">
                        <div className="text-center">
                            <Button label="Collect"
                                    id={`${this.state.badge_id}_button`}
                                    onClick={this.collect} />
                        </div>
                    </div>
                    :null
                }
            </div>
* */

BadgeCollect.propTypes = {
    badge_id: PropTypes.number.isRequired,
    onCollected: PropTypes.func,
    bite_id: PropTypes.number,
    asset_id: PropTypes.number,
    userBadge: PropTypes.object,
    collected: PropTypes.bool,
    badge: PropTypes.object,
    animate: PropTypes.bool,
    lang: PropTypes.string.isRequired,
    userData: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

BadgeCollect.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let badges = appHelper.getArrayObjectByKey(localStorage.bites, "bite_id", ownProps.bite_id).badges;
    let badgeUserData = appHelper.getArrayObjectByKey(state.userData.bites, "bite_id", ownProps.bite_id).badges;
    let lang = state.userData.lang;
    return {
        lang:lang,
        userData: state.userData,
        badge: appHelper.getArrayObjectByKey(badges, "badge_id", ownProps.badge_id),
        userBadge: appHelper.getArrayObjectByKey(badgeUserData, "badge_id", ownProps.badge_id),

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, userDataActions, trackingDataActions, appDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(BadgeCollect);



/** WEBPACK FOOTER **
 ** ./src/components/objects/badges/BadgeCollect.js
 **/